
import profile from '@/utils/profile'
import { jsFn } from '@/utils/js-fn'
import { post } from '@/api/http'

let hostname = window.location.hostname
var serverLocation = jsFn.isCN() ? 'cn' : 'global'

if(hostname.indexOf('localhost') === 0) {
    serverLocation = 'global'
}

var apiUrl = profile.sokmgrApi[serverLocation]

export default {
    // 加入頻道
    applyChannel: function(schoolCode) {
        return new Promise((resolve, reject) => {
            let data = {
                school_shortcode: schoolCode
            }

            post(apiUrl + '/api/school/apply-join-channel', data).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    }
}
